import { put } from 'redux-saga/effects';

import makeRequest from 'rdx/utils/makeRequest';
import putErrorActions from 'rdx/utils/putErrorActions';
import { newMessageEvent } from 'rdx/modules/messages/slice';

function* changeGroupOwner({ payload: { action, params, onSuccess } }) {
  const { success, error } = yield* makeRequest.action(action, params);
  if (success) {
    yield put(newMessageEvent({ text: 'Group Owner Changed' }));
    if (onSuccess) {
      onSuccess();
    }
  } else if (error) {
    yield* putErrorActions({ error });
  }
  return null;
}

export default changeGroupOwner;
